import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Small floating control that appears once the visitor has scrolled a screen
 * or so, and smoothly returns them to the top of the page.
 */
export const BackToTop = ({ className }: { className?: string }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Back to top"
      className={cn(
        "fixed right-6 z-40 h-11 w-11 rounded-full border border-border bg-background/90 backdrop-blur",
        "text-foreground shadow-lg flex items-center justify-center",
        "transition-all duration-300 hover:bg-primary hover:text-primary-foreground hover:-translate-y-0.5",
        "bottom-40 md:bottom-24",
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none",
        className
      )}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default BackToTop;
